import { cardClasses, css, iconButtonClasses, styled } from '@mui/material';

export const StyledNotificationsContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};

    & > div:last-of-type {
      margin-bottom: ${theme.spacing('2XL')};
    }

    ${theme.breakpoints.up('desktop')} {
      & > div:last-of-type {
        margin-bottom: ${theme.spacing('6XL')};
      }
    }
  `
);

export const StyledVerticalContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledDashboardCardsContainer = styled('div')(
  ({ theme }) => css`
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('LARGE')};

    .${cardClasses.root} {
      flex-grow: 1;
      width: 100%;
    }

    ${theme.breakpoints.up('desktop')} {
      flex-direction: row;
    }
  `
);

export const StyledDashboardCardContent = styled('div')(
  ({ theme }) => css`
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    height: 100%;
    padding: ${theme.spacing('LARGE')};

    .${iconButtonClasses.root} {
      align-self: center;
    }

    ${theme.breakpoints.up('desktop')} {
      column-gap: ${theme.spacing('SMALL')};
    }
  `
);

export const StyledDashboardCardTextContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    row-gap: ${theme.spacing('XSMALL')};
  `
);
